const initThe925Hero = (scope = document) => {
  scope.querySelectorAll('[data-the925-hero]').forEach((hero) => {
    if (hero.dataset.the925Ready) return;
    hero.dataset.the925Ready = 'true';
    const slides = [...hero.querySelectorAll('.the925-hero__slide')];
    const copy = hero.querySelector('[data-the925-hero-copy-target]');
    if (slides.length < 2) return;
    let index = 0;
    const showSlide = (nextIndex) => {
      slides[index].classList.remove('is-active');
      index = nextIndex;
      slides[index].classList.add('is-active');
      if (copy && slides[index].dataset.the925HeroCopy) {
        copy.textContent = slides[index].dataset.the925HeroCopy;
      }
    };
    if (copy && slides[0].dataset.the925HeroCopy) {
      copy.textContent = slides[0].dataset.the925HeroCopy;
    }
    window.setInterval(() => {
      showSlide((index + 1) % slides.length);
    }, 4200);
  });
};

const initThe925Carousel = (scope = document) => {
  scope.querySelectorAll('[data-the925-carousel]').forEach((carousel) => {
    if (carousel.dataset.the925Ready) return;
    carousel.dataset.the925Ready = 'true';

    const track = carousel.querySelector('[data-the925-carousel-track]');
    const viewport = carousel.querySelector('.the925-discover__viewport');
    const originals = [...carousel.querySelectorAll('[data-the925-slide]')];
    const dotsContainer = carousel.querySelector('[data-the925-carousel-dots]');
    const status = carousel.querySelector('[data-the925-carousel-status]');
    if (!track || !viewport || originals.length < 2) return;

    let page = 0;
    let resetTimer;
    let pointerStart = null;
    let itemsPerPage = 3;
    let visibleItems = 3.1;
    let pageCount = Math.ceil(originals.length / itemsPerPage);

    const setLayout = () => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      itemsPerPage = mobile ? 1 : 3;
      visibleItems = mobile ? 1.15 : 3.1;
      pageCount = Math.ceil(originals.length / itemsPerPage);
      carousel.style.setProperty('--the925-visible', visibleItems);
      page = Math.min(page, pageCount - 1);
      buildDots();
      render(false);
    };

    const updateAccessibility = () => {
      const start = page * itemsPerPage;
      const end = start + itemsPerPage;
      originals.forEach((slide, index) => {
        const visible = index >= start && index < end;
        slide.setAttribute('aria-hidden', String(!visible));
        const link = slide.querySelector('a');
        if (link) link.tabIndex = visible ? 0 : -1;
      });
      [...dotsContainer.querySelectorAll('button')].forEach((dot, index) => {
        dot.setAttribute('aria-current', index === page ? 'true' : 'false');
        dot.querySelector('span')?.classList.toggle('is-active', index === page);
      });
      status.textContent = `Discover your style page ${page + 1} of ${pageCount}`;
    };

    const offsetFor = (targetPage) => targetPage * itemsPerPage * (100 / visibleItems);

    const render = (animate = true, targetPage = page) => {
      track.classList.toggle('is-no-transition', !animate);
      track.style.transform = `translateX(-${offsetFor(targetPage)}%)`;
      updateAccessibility();
      if (!animate) requestAnimationFrame(() => track.classList.remove('is-no-transition'));
    };

    const buildDots = () => {
      dotsContainer.innerHTML = '';
      for (let index = 0; index < pageCount; index += 1) {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `Go to Discover your style page ${index + 1}`);
        button.innerHTML = '<span aria-hidden="true"></span>';
        button.addEventListener('click', () => {
          window.clearTimeout(resetTimer);
          page = index;
          render(true);
        });
        dotsContainer.appendChild(button);
      }
    };

    const advance = () => {
      window.clearTimeout(resetTimer);
      if (page < pageCount - 1) {
        page += 1;
        render(true);
        return;
      }
      render(true, pageCount);
      resetTimer = window.setTimeout(() => {
        page = 0;
        render(false);
      }, 1020);
    };

    const previous = () => {
      window.clearTimeout(resetTimer);
      page = page === 0 ? pageCount - 1 : page - 1;
      render(true);
    };

    viewport.addEventListener('pointerdown', (event) => { pointerStart = event.clientX; });
    viewport.addEventListener('pointerup', (event) => {
      if (pointerStart === null) return;
      const distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) > 45) distance < 0 ? advance() : previous();
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(setLayout, 150);
    });

    setLayout();
  });
};

const initThe925ShopCarousel = (scope = document) => {
  scope.querySelectorAll('[data-the925-shop-carousel]').forEach((carousel) => {
    if (carousel.dataset.the925Ready) return;
    carousel.dataset.the925Ready = 'true';
    const slides = [...carousel.querySelectorAll('.the925-shop-intro__slide')];
    if (slides.length < 2) return;
    let index = 0;
    window.setInterval(() => {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, 4200);
  });
};

const initThe925 = (scope = document) => {
  initThe925Hero(scope);
  initThe925ShopCarousel(scope);
  initThe925Carousel(scope);
};

document.addEventListener('DOMContentLoaded', () => initThe925());
document.addEventListener('shopify:section:load', (event) => initThe925(event.target));


/* UI parity enhancements - draft review theme only */
(() => {
  const svgNS = 'http://www.w3.org/2000/svg';
  const makeSvg = (kind) => {
    const svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('viewBox', '0 0 48 48');
    svg.setAttribute('width', '29');
    svg.setAttribute('height', '29');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    const addPath = (d, attrs = {}) => {
      const path = document.createElementNS(svgNS, 'path');
      path.setAttribute('d', d);
      Object.entries(attrs).forEach(([key, value]) => path.setAttribute(key, value));
      svg.append(path);
    };
    if (kind === 'bag') {
      addPath('M24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0Z', { fill: 'white' });
      addPath('M18.375 19.3125V18.6875C18.375 15.5809 20.8934 13.0625 24 13.0625C27.1066 13.0625 29.625 15.5809 29.625 18.6875V19.3125H33.375C34.2379 19.3125 34.9375 20.0121 34.9375 20.875V31.5C34.9375 33.3985 33.3985 34.9375 31.5 34.9375H16.5C14.6015 34.9375 13.0625 33.3985 13.0625 31.5V20.875C13.0625 20.0121 13.7621 19.3125 14.625 19.3125H18.375ZM20.25 19.3125H27.75V18.6875C27.75 16.6164 26.0711 14.9375 24 14.9375C21.9289 14.9375 20.25 16.6164 20.25 18.6875V19.3125ZM18.375 21.1875H14.9375V31.5C14.9375 32.3629 15.6371 33.0625 16.5 33.0625H31.5C32.3629 33.0625 33.0625 32.3629 33.0625 31.5V21.1875H29.625V24C29.625 24.5178 29.2053 24.9375 28.6875 24.9375C28.1697 24.9375 27.75 24.5178 27.75 24V21.1875H20.25V24C20.25 24.5178 19.8303 24.9375 19.3125 24.9375C18.7947 24.9375 18.375 24.5178 18.375 24V21.1875Z', { fill: '#121212' });
    } else if (kind === 'star') {
      addPath('M24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0Z', { fill: 'white' });
      addPath('M24 12.5L27.4 19.4L35 20.5L29.5 25.8L30.8 33.4L24 29.8L17.2 33.4L18.5 25.8L13 20.5L20.6 19.4L24 12.5Z', { fill: '#121212' });
    } else {
      addPath('M24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0Z', { fill: 'white' });
      addPath('M26.5 20.5H21.5V35H26.5V20.5ZM24 11.5C22.2 11.5 21 12.8 21 14.5C21 16.3 22.2 17.5 24 17.5C25.8 17.5 27 16.3 27 14.5C27 12.8 25.8 11.5 24 11.5Z', { fill: '#121212' });
    }
    return svg;
  };
  const enhanceButtons = () => {
    document.querySelectorAll('.the925-button').forEach((button) => {
      const icon = button.querySelector('.the925-button__icon');
      if (!icon || icon.dataset.parityIcon) return;
      const label = button.textContent.trim().toLowerCase();
      const kind = label.includes('shop now') ? 'bag' : label.includes('review') ? 'star' : 'info';
      icon.replaceChildren(makeSvg(kind));
      icon.dataset.parityIcon = kind;
    });
  };
  const addWordmark = () => {
    const logo = document.querySelector('.the925-logo');
    if (!logo || logo.querySelector('.the925-logo__wordmark')) return;
    const wordmark = document.createElement('span');
    wordmark.className = 'the925-logo__wordmark';
    wordmark.textContent = 'THE 925 CLUB';
    logo.append(wordmark);
  };
  const initOfferCarousel = (section) => {
    const carousel = section?.querySelector('[data-the925-offer-carousel]');
    const track = carousel?.querySelector('[data-the925-offer-track]');
    const originals = track ? [...track.querySelectorAll('[data-the925-offer-slide]')] : [];
    if (!carousel || !track || originals.length === 0 || carousel.dataset.ready === 'true') return;

    carousel.dataset.ready = 'true';
    const status = section.querySelector('[data-the925-offer-status]');
    const position = carousel.querySelector('[data-the925-offer-position]');
    const controls = carousel.querySelector('[data-the925-offer-controls]');
    const dots = carousel.querySelector('[data-the925-offer-dots]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = 0;
    let timer = 0;
    let touchStart = null;
    let suppressClick = false;

    const clone = originals.length > 1 ? originals[0].cloneNode(true) : null;
    if (clone) {
      clone.dataset.the925OfferClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.tabIndex = -1;
      track.append(clone);
    }
    const rendered = clone ? [...originals, clone] : originals;

    const logicalIndex = () => index === originals.length ? 0 : index;
    const render = (animate = true) => {
      track.classList.toggle('is-resetting', !animate || reducedMotion);
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      const active = logicalIndex();
      originals.forEach((slide, slideIndex) => {
        const visible = slideIndex === active;
        slide.setAttribute('aria-hidden', String(!visible));
        slide.tabIndex = visible ? 0 : -1;
      });
      if (clone) {
        clone.setAttribute('aria-hidden', 'true');
        clone.tabIndex = -1;
      }
      [...(dots?.querySelectorAll('button') || [])].forEach((dot, dotIndex) => {
        dot.setAttribute('aria-current', dotIndex === active ? 'true' : 'false');
      });
      if (position && originals.length > 1) position.textContent = 'Offer ' + (active + 1) + ' of ' + originals.length;
      if (!animate || reducedMotion) requestAnimationFrame(() => track.classList.remove('is-resetting'));
    };

    const next = () => {
      if (originals.length < 2) return;
      index += 1;
      render(true);
    };
    const previous = () => {
      if (originals.length < 2) return;
      if (index === 0) {
        index = originals.length;
        render(false);
        requestAnimationFrame(() => requestAnimationFrame(() => {
          index = originals.length - 1;
          render(true);
        }));
      } else {
        index -= 1;
        render(true);
      }
    };
    const schedule = () => {
      window.clearInterval(timer);
      if (!reducedMotion && originals.length > 1 && !document.hidden) timer = window.setInterval(next, 4800);
    };

    if (dots) {
      dots.replaceChildren();
      originals.forEach((slide, dotIndex) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Go to offer ' + (dotIndex + 1));
        dot.addEventListener('click', () => {
          index = dotIndex;
          render(true);
          schedule();
        });
        dots.append(dot);
      });
    }
    if (controls) controls.hidden = originals.length < 2;

    rendered.forEach((slide) => {
      slide.addEventListener('click', async () => {
        if (suppressClick) return;
        const code = String(slide.dataset.the925OfferCode || '').trim();
        if (!code) {
          if (status) status.textContent = 'This offer does not have a code to copy.';
          return;
        }
        try {
          await navigator.clipboard.writeText(code);
          if (status) status.textContent = code + ' copied';
        } catch (error) {
          if (status) status.textContent = 'Use code ' + code + ' at checkout';
        }
      });
    });

    track.addEventListener('transitionend', () => {
      if (index !== originals.length) return;
      index = 0;
      render(false);
    });
    carousel.addEventListener('touchstart', (event) => {
      touchStart = event.touches[0]?.clientX ?? null;
    }, { passive: true });
    carousel.addEventListener('touchend', (event) => {
      if (touchStart === null) return;
      const end = event.changedTouches[0]?.clientX;
      const distance = typeof end === 'number' ? end - touchStart : 0;
      touchStart = null;
      if (Math.abs(distance) < 40) return;
      suppressClick = true;
      distance < 0 ? next() : previous();
      schedule();
      window.setTimeout(() => { suppressClick = false; }, 0);
    }, { passive: true });
    carousel.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      event.key === 'ArrowRight' ? next() : previous();
      schedule();
    });
    carousel.addEventListener('mouseenter', () => window.clearInterval(timer));
    carousel.addEventListener('mouseleave', schedule);
    carousel.addEventListener('focusin', () => window.clearInterval(timer));
    carousel.addEventListener('focusout', (event) => {
      if (!carousel.contains(event.relatedTarget)) schedule();
    });
    document.addEventListener('visibilitychange', schedule);

    render(false);
    schedule();
  };

  const addOffers = () => {
    const budget = document.querySelector('.the925-budget');
    if (!budget) return;
    let section = document.querySelector('[data-the925-offers]');
    if (!section) {
      section = document.createElement('section');
      section.className = 'the925-offers';
      section.dataset.the925Offers = '';
      section.setAttribute('aria-labelledby', 'the925-offers-title');

      const head = document.createElement('div');
      head.className = 'the925-offers__head';
      const title = document.createElement('h2');
      title.id = 'the925-offers-title';
      title.textContent = 'Offers';
      const copy = document.createElement('p');
      copy.textContent = 'Click on an offer to copy its discount code, then apply it at checkout to enjoy the deal.';
      head.append(title, copy);

      const carousel = document.createElement('div');
      carousel.className = 'the925-offers__carousel';
      carousel.dataset.the925OfferCarousel = '';
      carousel.setAttribute('role', 'region');
      carousel.setAttribute('aria-roledescription', 'carousel');
      carousel.setAttribute('aria-label', 'Current offers');
      const viewport = document.createElement('div');
      viewport.className = 'the925-offers__viewport';
      const track = document.createElement('div');
      track.className = 'the925-offers__track';
      track.dataset.the925OfferTrack = '';
      const banner = document.createElement('button');
      banner.type = 'button';
      banner.className = 'the925-offers__banner the925-offers__slide';
      banner.dataset.the925OfferSlide = '';
      banner.dataset.the925OfferCode = 'FIRST15%';
      banner.setAttribute('aria-label', 'Copy offer code FIRST15% for First purchase');
      const image = document.createElement('img');
      image.src = 'https://images.the925club.com/offers/1786521150607-5c472fe8c8ee.png';
      image.alt = 'First purchase offer. Code FIRST15%.';
      image.width = 1536;
      image.height = 512;
      image.loading = 'eager';
      banner.append(image);
      track.append(banner);
      viewport.append(track);

      const controls = document.createElement('div');
      controls.className = 'the925-offers__controls';
      controls.dataset.the925OfferControls = '';
      controls.hidden = true;
      const dots = document.createElement('div');
      dots.className = 'the925-offers__dots';
      dots.dataset.the925OfferDots = '';
      dots.setAttribute('aria-label', 'Choose an offer');
      controls.append(dots);
      const position = document.createElement('p');
      position.className = 'visually-hidden';
      position.dataset.the925OfferPosition = '';
      position.setAttribute('aria-live', 'polite');
      carousel.append(viewport, controls, position);

      const status = document.createElement('p');
      status.className = 'the925-offers__status';
      status.dataset.the925OfferStatus = '';
      status.setAttribute('aria-live', 'polite');
      section.append(head, carousel, status);
      budget.parentNode.insertBefore(section, budget);
    }
    initOfferCarousel(section);
  };
  const enhanceProducts = () => {
    const grid = document.querySelector('.the925-products__grid');
    if (!grid || grid.dataset.parityReady) return;
    grid.dataset.parityReady = 'true';
    const products = Array.from(grid.querySelectorAll('.the925-product'));
    products.reverse().forEach((product) => grid.append(product));
    products.forEach((product) => {
      if (!product.querySelector('.the925-product__badge')) {
        const badge = document.createElement('span');
        badge.className = 'the925-product__badge';
        badge.textContent = 'Best seller';
        product.append(badge);
      }
      const price = product.querySelector('.the925-product__line span:first-child');
      if (price) price.textContent = price.textContent.replace(/^Rs\.\s*/i, '₹').replace(/\.00$/, '');
    });
    const pagination = document.createElement('div');
    pagination.className = 'the925-pagination';
    pagination.setAttribute('aria-label', 'Best sellers pages');
    grid.after(pagination);
    let ticking = false;
    const cardsPerPage = () => window.matchMedia('(max-width: 749px)').matches ? 2 : 3;
    const render = () => {
      const pages = Math.ceil(products.length / cardsPerPage());
      const active = Math.min(pages - 1, Math.round(grid.scrollLeft / Math.max(grid.clientWidth, 1)));
      pagination.replaceChildren();
      for (let index = 0; index < pages; index += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Go to Best sellers page ' + (index + 1));
        dot.setAttribute('aria-current', index === active ? 'true' : 'false');
        dot.addEventListener('click', () => grid.scrollTo({ left: index * grid.clientWidth, behavior: 'smooth' }));
        pagination.append(dot);
      }
    };
    grid.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { render(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', render, { passive: true });
    render();
  };
  const enhanceTrust = () => {
    const grid = document.querySelector('.the925-trust__grid');
    if (!grid || grid.dataset.parityReady) return;

    const items = Array.from(grid.querySelectorAll('.the925-trust__item'));
    if (items.length < 2) return;
    grid.dataset.parityReady = 'true';

    const viewport = document.createElement('div');
    viewport.className = 'the925-trust__viewport';
    viewport.setAttribute('role', 'region');
    viewport.setAttribute('aria-roledescription', 'carousel');
    viewport.setAttribute('aria-label', 'Why choose us benefits');
    grid.before(viewport);
    viewport.append(grid);

    const controls = document.createElement('div');
    controls.className = 'the925-trust__controls';
    const previous = document.createElement('button');
    previous.type = 'button';
    previous.setAttribute('aria-label', 'Previous benefit');
    previous.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><path d="m15 5-7 7 7 7"/></svg>';
    const next = document.createElement('button');
    next.type = 'button';
    next.setAttribute('aria-label', 'Next benefit');
    next.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>';
    controls.append(previous, next);

    const status = document.createElement('p');
    status.className = 'the925-trust__status';
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    viewport.append(controls, status);

    items.forEach((item, itemIndex) => {
      item.setAttribute('role', 'group');
      item.setAttribute('aria-roledescription', 'slide');
      item.setAttribute('aria-label', (itemIndex + 1) + ' of ' + items.length);
    });

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0;
    let timer = 0;
    let touchStart = null;
    let paused = false;

    const stopTimer = () => {
      if (timer) window.clearInterval(timer);
      timer = 0;
    };

    const render = (announce = false) => {
      if (!mobileQuery.matches) {
        grid.style.removeProperty('transform');
        items.forEach((item) => item.setAttribute('aria-hidden', 'false'));
        controls.hidden = true;
        status.textContent = '';
        return;
      }
      controls.hidden = false;
      grid.style.transform = 'translateX(-' + (index * 100) + '%)';
      items.forEach((item, itemIndex) => item.setAttribute('aria-hidden', String(itemIndex !== index)));
      status.textContent = announce ? 'Showing benefit ' + (index + 1) + ' of ' + items.length : '';
    };

    const startTimer = () => {
      stopTimer();
      if (!mobileQuery.matches || reducedMotionQuery.matches || paused || document.hidden) return;
      timer = window.setInterval(() => {
        index = (index + 1) % items.length;
        render(false);
      }, 2500);
    };

    const go = (step) => {
      index = (index + step + items.length) % items.length;
      render(true);
      startTimer();
    };

    previous.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    viewport.addEventListener('pointerenter', () => { paused = true; stopTimer(); });
    viewport.addEventListener('pointerleave', () => { paused = false; startTimer(); });
    viewport.addEventListener('focusin', () => { paused = true; stopTimer(); });
    viewport.addEventListener('focusout', (event) => {
      if (viewport.contains(event.relatedTarget)) return;
      paused = false;
      startTimer();
    });
    viewport.addEventListener('touchstart', (event) => {
      touchStart = event.touches[0]?.clientX ?? null;
      paused = true;
      stopTimer();
    }, { passive: true });
    viewport.addEventListener('touchend', (event) => {
      const end = event.changedTouches[0]?.clientX;
      if (typeof touchStart === 'number' && typeof end === 'number' && Math.abs(end - touchStart) >= 40) go(end < touchStart ? 1 : -1);
      touchStart = null;
      paused = false;
      startTimer();
    }, { passive: true });

    const syncMode = () => { render(false); startTimer(); };
    mobileQuery.addEventListener?.('change', syncMode);
    reducedMotionQuery.addEventListener?.('change', startTimer);
    document.addEventListener('visibilitychange', startTimer);
    render(false);
    startTimer();
  };
  const improveStoryAlts = () => {
    const labels = ['Silver cross jewellery set','Bow-shaped silver earrings','Circular pendant and earring set','Woman styling silver bracelet and ring','Woman wearing stacked silver rings','Minimal silver necklace set','Green backdrop pendant and earrings set','Rose-tone jewellery flat lay'];
    document.querySelectorAll('.the925-story__mosaic img').forEach((image, index) => {
      if (labels[index]) image.alt = labels[index];
    });
  };
  const syncDiscover = () => {
    const discover = document.querySelector('.the925-discover');
    if (!discover) return;
    discover.style.setProperty('--the925-visible', window.matchMedia('(max-width: 749px)').matches ? '2' : '3.1', 'important');
  };
  const init = () => {
    enhanceButtons();
    addWordmark();
    addOffers();
    enhanceProducts();
    enhanceTrust();
    improveStoryAlts();
    syncDiscover();
    window.addEventListener('resize', syncDiscover, { passive: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();


/* Keep the story title on one readable line without joining words. */
(() => {
  const fixStoryTitle = () => {
    const lineBreak = document.querySelector('.the925-story .the925-heading br');
    if (lineBreak) lineBreak.replaceWith(document.createTextNode(' '));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixStoryTitle, { once: true });
  else fixStoryTitle();
})();


/* Shopping controls: account menu, budget navigation, filter heading */
(() => {
  const enhanceAccountMenu = () => {
    const accountLink = document.querySelector('.the925-account');
    if (!accountLink || accountLink.dataset.menuReady === 'true') return;

    accountLink.dataset.menuReady = 'true';
    const wrapper = document.createElement('div');
    wrapper.className = 'the925-account-wrap';
    accountLink.before(wrapper);
    wrapper.append(accountLink);

    accountLink.setAttribute('aria-haspopup', 'menu');
    accountLink.setAttribute('aria-expanded', 'false');
    accountLink.setAttribute('aria-controls', 'the925-account-menu');

    const menu = document.createElement('div');
    menu.id = 'the925-account-menu';
    menu.className = 'the925-account-menu';
    menu.setAttribute('role', 'menu');
    menu.setAttribute('aria-label', 'Account menu');
    menu.setAttribute('aria-hidden', 'true');
    menu.inert = true;

    const createIcon = (markup) => {
      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('viewBox', '0 0 24 24');
      icon.setAttribute('fill', 'none');
      icon.setAttribute('stroke', 'currentColor');
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = markup;
      return icon;
    };

    const createMenuLink = (text, href, iconMarkup = '', primary = false) => {
      const link = document.createElement('a');
      link.className = 'the925-account-menu__link';
      if (primary) link.classList.add('the925-account-menu__link--primary');
      link.href = href;
      link.setAttribute('role', 'menuitem');
      if (iconMarkup) link.append(createIcon(iconMarkup));
      link.append(document.createTextNode(text));
      return link;
    };

    const divider = document.createElement('hr');
    divider.className = 'the925-account-menu__divider';

    menu.append(
      createMenuLink('Login / Signup', '/account/login', '', true),
      divider,
      createMenuLink('Orders', '/account', '<path d="M5 8h14l1 13H4L5 8Z"/><path d="M9 9V6a3 3 0 0 1 6 0v3"/>'),
      createMenuLink('Wishlist', '/pages/wishlist', '<path d="M20.8 4.8a5.5 5.5 0 0 0-7.8 0L12 5.8l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.4 1-1a5.5 5.5 0 0 0 0-7.8Z"/>'),
      createMenuLink('Offers', '/pages/offers', '<path d="M9 18h6M10 22h4"/><path d="M8.2 14.5A7 7 0 1 1 15.8 14.5C14.7 15.4 14 16.4 14 18h-4c0-1.6-.7-2.6-1.8-3.5Z"/>')
    );
    wrapper.append(menu);

    const menuLinks = [...menu.querySelectorAll('[role="menuitem"]')];
    const setOpen = (isOpen, focusFirst = false) => {
      menu.classList.toggle('is-open', isOpen);
      menu.setAttribute('aria-hidden', String(!isOpen));
      menu.inert = !isOpen;
      accountLink.setAttribute('aria-expanded', String(isOpen));
      if (isOpen && focusFirst) window.setTimeout(() => menuLinks[0]?.focus(), 0);
    };

    accountLink.addEventListener('click', (event) => {
      event.preventDefault();
      setOpen(accountLink.getAttribute('aria-expanded') !== 'true');
    });
    accountLink.addEventListener('keydown', (event) => {
      if (!['ArrowDown', 'Enter', ' '].includes(event.key)) return;
      if (event.key === 'Enter' || event.key === ' ') return;
      event.preventDefault();
      setOpen(true, true);
    });

    document.addEventListener('pointerdown', (event) => {
      if (!wrapper.contains(event.target)) setOpen(false);
    });

    wrapper.addEventListener('focusout', (event) => {
      if (!wrapper.contains(event.relatedTarget)) setOpen(false);
    });

    wrapper.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        setOpen(false);
        accountLink.focus();
        return;
      }
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const current = Math.max(0, menuLinks.indexOf(document.activeElement));
      const target = event.key === 'Home' ? 0 : event.key === 'End' ? menuLinks.length - 1 : event.key === 'ArrowDown' ? (current + 1) % menuLinks.length : (current - 1 + menuLinks.length) % menuLinks.length;
      menuLinks[target]?.focus();
    });
  };

  const enhanceBudgetLinks = () => {
    document.querySelectorAll('.the925-budget__card').forEach((link) => {
      try {
        const url = new URL(link.getAttribute('href') || '', window.location.origin);
        if (url.origin !== window.location.origin || url.pathname !== '/collections/all') return;
        url.hash = 'ProductGridContainer';
        link.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (error) {
        // Leave malformed or third-party links untouched.
      }
    });
  };

  const enhanceFilterHeading = () => {
    document.querySelectorAll('.facets__heading--vertical').forEach((heading) => {
      heading.textContent = 'Filter Options';
    });
  };

  const initShoppingControls = () => {
    enhanceAccountMenu();
    enhanceBudgetLinks();
    enhanceFilterHeading();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShoppingControls, { once: true });
  } else {
    initShoppingControls();
  }
})();


/* React shop parity: real filters, catalogue order, carousel and budget behavior */
(() => {
  const SHOP_SORT = 'created-ascending';
  const SHOP_PAGE_SIZE = 12;
  const collectionOptions = [
    { label: 'Rings', handle: 'rings', count: 17 },
    { label: 'Necklace', handle: 'necklace', count: 14 },
    { label: 'Toe Rings', handle: 'toe-rings', count: 21 },
    { label: 'Anklets', handle: 'anklets', count: 33 },
    { label: 'Chains', handle: 'chains', count: 40 },
    { label: 'Bracelets', handle: 'bracelets', count: 100 },
    { label: 'Earrings', handle: 'earrings', count: 52 },
    { label: 'Chain Pendants', handle: 'chain-pendants', count: 75 }
  ];

  const getCollectionState = () => {
    const parts = window.location.pathname.split('/').filter(Boolean);
    if (parts[0] !== 'collections') return null;
    return {
      handle: parts[1] || 'all',
      tag: ['men', 'women'].includes(parts[2]) ? parts[2] : ''
    };
  };

  const buildShopUrl = ({ handle, tag, changeParams } = {}) => {
    const state = getCollectionState() || { handle: 'all', tag: '' };
    const url = new URL(window.location.href);
    const nextHandle = handle || state.handle;
    const nextTag = tag === undefined ? state.tag : tag;
    url.pathname = '/collections/' + encodeURIComponent(nextHandle) + (nextTag ? '/' + encodeURIComponent(nextTag) : '');
    url.searchParams.delete('page');
    if (!url.searchParams.has('sort_by')) url.searchParams.set('sort_by', SHOP_SORT);
    if (typeof changeParams === 'function') changeParams(url.searchParams);
    url.hash = 'ProductGridContainer';
    return url.pathname + url.search + url.hash;
  };

  const ensureCatalogueOrder = () => {
    const state = getCollectionState();
    if (!state) return false;
    const url = new URL(window.location.href);
    if (url.searchParams.has('sort_by')) return false;
    url.searchParams.set('sort_by', SHOP_SORT);
    url.searchParams.delete('page');
    window.location.replace(url.pathname + url.search + url.hash);
    return true;
  };

  const initShopLoop = () => {
    const carousel = document.querySelector('[data-the925-shop-loop]');
    if (!carousel || carousel.dataset.loopReady === 'true') return;
    const track = carousel.querySelector('[data-the925-shop-track]');
    const candidates = track ? [...track.querySelectorAll('[data-the925-shop-slide]')] : [];
    if (!track || candidates.length === 0) return;

    const state = getCollectionState() || { handle: 'all' };
    const categoryHandles = new Set(candidates.map((slide) => slide.dataset.the925ShopCategory));
    const activeCategory = categoryHandles.has(state.handle) ? state.handle : '';
    const originals = activeCategory ? candidates.filter((slide) => slide.dataset.the925ShopCategory === activeCategory) : candidates;
    candidates.filter((slide) => !originals.includes(slide)).forEach((slide) => slide.remove());
    originals.forEach((slide, slideIndex) => {
      const category = slide.dataset.the925ShopCategory;
      const link = slide.querySelector('[data-the925-shop-link]');
      if (link && category) link.href = buildShopUrl({ handle: category });
      const image = slide.querySelector('img');
      if (image && slideIndex === 0) {
        image.loading = 'eager';
        image.fetchPriority = 'high';
      }
    });

    carousel.dataset.loopReady = 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const clone = originals.length > 1 ? originals[0].cloneNode(true) : null;
    if (clone) {
      clone.dataset.the925ShopClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelector('a')?.setAttribute('tabindex', '-1');
      track.append(clone);
    }
    let index = 0;
    let timer = 0;
    let pointerStart = null;

    const render = (animate = true) => {
      track.classList.toggle('is-resetting', !animate || reducedMotion);
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      const active = index === originals.length ? 0 : index;
      originals.forEach((slide, slideIndex) => {
        const visible = slideIndex === active;
        slide.setAttribute('aria-hidden', String(!visible));
        const link = slide.querySelector('a');
        if (link) link.tabIndex = visible ? 0 : -1;
      });
      if (clone) {
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelector('a')?.setAttribute('tabindex', '-1');
      }
      if (!animate || reducedMotion) requestAnimationFrame(() => track.classList.remove('is-resetting'));
    };
    const next = () => {
      if (originals.length < 2) return;
      index += 1;
      render(true);
    };
    const previous = () => {
      if (originals.length < 2) return;
      if (index === 0) {
        index = originals.length;
        render(false);
        requestAnimationFrame(() => requestAnimationFrame(() => {
          index = originals.length - 1;
          render(true);
        }));
      } else {
        index -= 1;
        render(true);
      }
    };
    const schedule = () => {
      window.clearInterval(timer);
      if (!reducedMotion && originals.length > 1 && !document.hidden) timer = window.setInterval(next, 4500);
    };

    track.addEventListener('transitionend', () => {
      if (index !== originals.length) return;
      index = 0;
      render(false);
    });
    carousel.addEventListener('pointerdown', (event) => { pointerStart = event.clientX; });
    carousel.addEventListener('pointercancel', () => { pointerStart = null; });
    carousel.addEventListener('pointerup', (event) => {
      if (pointerStart === null) return;
      const distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) < 45) return;
      distance < 0 ? next() : previous();
      schedule();
    });
    carousel.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      event.key === 'ArrowRight' ? next() : previous();
      schedule();
    });
    carousel.addEventListener('mouseenter', () => window.clearInterval(timer));
    carousel.addEventListener('mouseleave', schedule);
    carousel.addEventListener('focusin', () => window.clearInterval(timer));
    carousel.addEventListener('focusout', (event) => {
      if (!carousel.contains(event.relatedTarget)) schedule();
    });
    document.addEventListener('visibilitychange', schedule);

    render(false);
    schedule();
  };

  const syncBudgetPills = () => {
    const selectedMax = new URL(window.location.href).searchParams.get('filter.v.price.lte');
    document.querySelectorAll('[data-the925-budget-max]').forEach((pill) => {
      const max = pill.dataset.the925BudgetMax;
      const selected = selectedMax === max;
      pill.setAttribute('aria-checked', String(selected));
      pill.href = buildShopUrl({
        changeParams: (params) => {
          if (selected) params.delete('filter.v.price.lte');
          else params.set('filter.v.price.lte', max);
        }
      });
    });
  };

  const createFilterOption = ({ label, count, href, selected, role = 'checkbox' }) => {
    const link = document.createElement('a');
    link.className = 'the925-filter-option';
    link.href = href;
    link.setAttribute('role', role);
    link.setAttribute('aria-checked', String(selected));

    const control = document.createElement('span');
    control.className = 'the925-filter-option__control';
    control.setAttribute('aria-hidden', 'true');
    const text = document.createElement('span');
    text.textContent = label;
    link.append(control, text);

    if (count !== undefined) {
      const countText = document.createElement('span');
      countText.className = 'the925-filter-option__count';
      countText.textContent = '(' + count + ')';
      link.append(countText);
      link.setAttribute('aria-label', label + ' (' + count + ')');
    }
    return link;
  };

  const createFilterGroup = (title, items) => {
    const section = document.createElement('section');
    section.className = 'the925-filter-group';
    const heading = document.createElement('h5');
    heading.className = 'the925-filter-group__title';
    heading.textContent = title;
    const options = document.createElement('div');
    options.className = 'the925-filter-group__options';
    items.forEach((item) => options.append(createFilterOption(item)));
    section.append(heading, options);
    return section;
  };

  const getCustomGroups = () => {
    const state = getCollectionState() || { handle: 'all', tag: '' };
    const params = new URL(window.location.href).searchParams;
    const ratings = params.getAll('rating');

    const collections = createFilterGroup('By Collections', collectionOptions.map((item) => ({
      ...item,
      role: 'radio',
      selected: state.handle === item.handle,
      href: buildShopUrl({ handle: item.handle })
    })));

    const genders = createFilterGroup('By Gender', [
      { label: 'Men', count: 25, role: 'radio', selected: state.tag === 'men', href: buildShopUrl({ tag: state.tag === 'men' ? '' : 'men' }) },
      { label: 'Women', count: 327, role: 'radio', selected: state.tag === 'women', href: buildShopUrl({ tag: state.tag === 'women' ? '' : 'women' }) }
    ]);

    const offerSelected = params.get('offer') === 'first-purchase';
    const offers = createFilterGroup('By Offers', [{
      label: 'First purchase',
      count: 352,
      selected: offerSelected,
      href: buildShopUrl({ changeParams: (next) => offerSelected ? next.delete('offer') : next.set('offer', 'first-purchase') })
    }]);

    const reviews = createFilterGroup('By Reviews', [5, 4, 3, 2, 1].map((rating) => {
      const value = String(rating);
      const selected = ratings.includes(value);
      return {
        label: '★'.repeat(rating) + ' ' + rating + ' Stars',
        selected,
        href: buildShopUrl({ changeParams: (next) => {
          const nextRatings = next.getAll('rating').filter((item) => item !== value);
          next.delete('rating');
          if (!selected) nextRatings.push(value);
          nextRatings.forEach((item) => next.append('rating', item));
        } })
      };
    }));

    const promotions = createFilterGroup('By Promotions', [
      { label: 'New Arrivals', selected: state.handle === 'new-arrivals', href: buildShopUrl({ handle: state.handle === 'new-arrivals' ? 'all' : 'new-arrivals' }) },
      { label: 'Best Sellers', selected: state.handle === 'best-sellers', href: buildShopUrl({ handle: state.handle === 'best-sellers' ? 'all' : 'best-sellers' }) }
    ]);

    return { collections, genders, offers, reviews, promotions };
  };

  const relabelNativeFilter = (details, label) => {
    if (!details) return;
    const summaryLabel = details.querySelector('.facets__summary-label') || details.querySelector('summary span');
    if (summaryLabel) {
      const selected = summaryLabel.querySelector('.facets__selected');
      summaryLabel.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) node.textContent = label + ' ';
      });
      if (!summaryLabel.textContent.trim().startsWith(label)) summaryLabel.prepend(document.createTextNode(label + ' '));
      if (selected) summaryLabel.append(selected);
    }
    details.open = true;
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  };

  const enhanceDesktopFilters = () => {
    const form = document.querySelector('#FacetFiltersForm');
    if (!form || form.dataset.the925Expanded === 'true') return;
    form.dataset.the925Expanded = 'true';

    const heading = form.querySelector('.facets__heading--vertical');
    if (heading) heading.textContent = 'Filter Options';
    const details = [...form.querySelectorAll('.facets__disclosure-vertical')];
    const availability = details.find((item) => item.id.includes('availability'));
    const price = details.find((item) => item.id.includes('price'));
    const groups = getCustomGroups();
    const firstDetails = details[0] || null;

    const filterList = firstDetails ? firstDetails.parentElement : form;
    [groups.collections, groups.genders, groups.offers].forEach((group) => filterList.insertBefore(group, firstDetails));
    relabelNativeFilter(price, 'By Price');
    relabelNativeFilter(availability, 'By Availability');
    if (price) filterList.append(price);
    filterList.append(groups.reviews, groups.promotions);
    if (availability) filterList.append(availability);

    const state = getCollectionState();
    const hasCustomFilter = state && (state.handle !== 'all' || state.tag) || new URL(window.location.href).searchParams.has('offer') || new URL(window.location.href).searchParams.has('rating');
    if (hasCustomFilter && heading && !form.querySelector('.the925-clear-filters')) {
      const clear = document.createElement('a');
      clear.className = 'the925-clear-filters';
      clear.href = '/collections/all?sort_by=' + encodeURIComponent(SHOP_SORT) + '#ProductGridContainer';
      clear.textContent = 'Clear All';
      heading.after(clear);
    }
  };

  const enhanceMobileFilters = () => {
    const main = document.querySelector('.mobile-facets__main');
    if (!main || main.dataset.the925Expanded === 'true') return;
    main.dataset.the925Expanded = 'true';
    const groups = getCustomGroups();
    const container = document.createElement('div');
    container.className = 'the925-filter-groups';
    container.append(groups.collections, groups.genders, groups.offers, groups.reviews, groups.promotions);
    main.prepend(container);
  };

  const simplifySortMenu = () => {
    document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      if (select.dataset.the925Ready === 'true') return;
      select.dataset.the925Ready = 'true';
      const labels = {
        'created-ascending': 'Featured',
        'created-descending': "What's new",
        'price-descending': 'Price high to low',
        'price-ascending': 'Price low to high',
        'best-selling': 'Customer rating'
      };
      [...select.options].forEach((option) => {
        if (labels[option.value]) option.textContent = labels[option.value];
        else option.remove();
      });
    });
  };

  const formatProductCount = () => {
    const count = document.querySelector('.product-count__text');
    if (!count || count.dataset.the925Ready === 'true') return;
    const numbers = (count.textContent.match(/[\d,]+/g) || []).map((value) => Number(value.replace(/,/g, '')));
    if (!numbers.length) return;
    const total = numbers.length > 1 ? numbers[0] : numbers[0];
    const page = Math.max(1, Number(new URL(window.location.href).searchParams.get('page') || 1));
    const start = total ? ((page - 1) * SHOP_PAGE_SIZE) + 1 : 0;
    const end = Math.min(page * SHOP_PAGE_SIZE, total);
    count.textContent = 'Showing ' + start + ' - ' + end + ' of ' + total + ' products';
    count.dataset.the925Ready = 'true';
  };

  const applyReviewState = () => {
    const ratings = new URL(window.location.href).searchParams.getAll('rating');
    const grid = document.querySelector('#product-grid');
    if (!grid || !ratings.length || grid.dataset.the925ReviewEmpty === 'true') return;
    grid.dataset.the925ReviewEmpty = 'true';
    [...grid.children].forEach((card) => { card.hidden = true; });
    const message = document.createElement('li');
    message.className = 'the925-no-results';
    message.textContent = 'No products match the selected review rating.';
    grid.prepend(message);
    const count = document.querySelector('.product-count__text');
    if (count) count.textContent = 'Showing 0 - 0 of 0 products';
  };

  const removeShopOffers = () => {
    if (!document.querySelector('[data-the925-shop]')) return;
    document.querySelectorAll('.the925-shop-intro .the925-offers').forEach((offer) => offer.remove());
  };

  const initShopParity = () => {
    if (!getCollectionState()) return;
    if (ensureCatalogueOrder()) return;
    removeShopOffers();
    initShopLoop();
    syncBudgetPills();
    enhanceDesktopFilters();
    enhanceMobileFilters();
    simplifySortMenu();
    formatProductCount();
    applyReviewState();
  };

  let scheduled = false;
  const scheduleInit = () => {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(() => {
      scheduled = false;
      initShopParity();
    }, 0);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initShopParity, { once: true });
  else initShopParity();
  document.addEventListener('shopify:section:load', scheduleInit);
  new MutationObserver(scheduleInit).observe(document.documentElement, { childList: true, subtree: true });
})();

(() => {
  const productSelector = '.product--thumbnail_slider, .product--thumbnail-slider';

  const syncAccordion = (details) => {
    const summary = details.querySelector('summary');
    const panel = details.querySelector('.accordion__content');
    const container = details.closest('.product__accordion');
    if (!summary || !panel || !container) return;

    if (!panel.id) panel.id = details.id ? details.id + '-panel' : 'ProductAccordionPanel-' + Math.random().toString(36).slice(2);
    summary.setAttribute('aria-controls', panel.id);
    summary.setAttribute('aria-expanded', String(details.open));
    container.classList.toggle('is-open', details.open);
  };

  const setupProductPage = (scope = document) => {
    const product = scope.querySelector?.(productSelector) || document.querySelector(productSelector);
    if (!product) return;

    const gallery = product.querySelector('media-gallery');
    if (gallery && !gallery.querySelector(':scope > .the925-pdp-badge')) {
      const badge = document.createElement('span');
      badge.className = 'the925-pdp-badge';
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = 'FIRST15%';
      gallery.append(badge);
    }

    const share = product.querySelector('share-button');
    if (share) share.classList.add('the925-pdp-share');
    if (gallery && share && share.parentElement !== gallery) gallery.append(share);

    if (gallery && gallery.dataset.the925NavigationReady !== 'true') {
      const thumbnails = Array.from(gallery.querySelectorAll('.thumbnail'));
      const previous = gallery.querySelector('.slider-buttons.quick-add-hidden.small-hide .slider-button--prev');
      const next = gallery.querySelector('.slider-buttons.quick-add-hidden.small-hide .slider-button--next');
      const changeMedia = (direction, event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!thumbnails.length) return;
        const active = Math.max(0, thumbnails.findIndex((button) => button.getAttribute('aria-current') === 'true'));
        const target = (active + direction + thumbnails.length) % thumbnails.length;
        thumbnails[target].click();
      };
      if (previous) previous.addEventListener('click', (event) => changeMedia(-1, event), true);
      if (next) next.addEventListener('click', (event) => changeMedia(1, event), true);
      gallery.dataset.the925NavigationReady = 'true';
    }

    const accordions = Array.from(product.querySelectorAll('.product__accordion details'));
    accordions.forEach((details) => {
      const panel = details.querySelector('.accordion__content');
      if (panel && !panel.querySelector(':scope > .the925-accordion-inner')) {
        const inner = document.createElement('div');
        inner.className = 'the925-accordion-inner';
        while (panel.firstChild) inner.append(panel.firstChild);
        panel.append(inner);
      }

      if (details.dataset.the925Ready !== 'true') {
        details.dataset.the925Ready = 'true';
        details.addEventListener('toggle', () => {
          if (details.open) {
            accordions.forEach((other) => {
              if (other !== details && other.open) other.open = false;
            });
          }
          accordions.forEach(syncAccordion);
        });
      }
      syncAccordion(details);
    });

    if (accordions.length && !accordions.some((details) => details.open)) accordions[0].open = true;
  };

  const initRelatedRail = (rail) => {
    if (!rail || rail.dataset.the925RailReady === 'true') return;
    const list = rail.querySelector('.product-grid');
    const items = Array.from(list?.children || []);
    if (!list || items.length < 2) return;

    rail.dataset.the925RailReady = 'true';
    const controls = document.createElement('div');
    controls.className = 'the925-rail-dots';
    controls.setAttribute('role', 'group');
    controls.setAttribute('aria-label', 'Related products carousel pages');
    rail.append(controls);

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const pageSize = () => window.matchMedia('(min-width: 990px)').matches ? 3 : 1;

    const render = () => {
      const count = Math.ceil(items.length / pageSize());
      controls.replaceChildren();
      for (let index = 0; index < count; index += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'the925-rail-dot';
        dot.setAttribute('aria-label', 'Show related products page ' + (index + 1));
        dot.addEventListener('click', () => {
          const target = items[index * pageSize()];
          if (!target) return;
          list.scrollTo({ left: target.offsetLeft - list.offsetLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        });
        controls.append(dot);
      }
      update();
    };

    const update = () => {
      const dots = Array.from(controls.children);
      if (!dots.length) return;
      const max = Math.max(1, list.scrollWidth - list.clientWidth);
      const active = Math.min(dots.length - 1, Math.round((list.scrollLeft / max) * (dots.length - 1)));
      dots.forEach((dot, index) => dot.setAttribute('aria-current', index === active ? 'true' : 'false'));
    };

    let ticking = false;
    list.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        ticking = false;
        update();
      });
    }, { passive: true });
    window.addEventListener('resize', render, { passive: true });
    render();
  };

  const init = (scope = document) => {
    setupProductPage(scope);
    document.querySelectorAll('product-recommendations.product-recommendations--loaded').forEach(initRelatedRail);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  new MutationObserver(() => init()).observe(document.documentElement, { childList: true, subtree: true });
})();


/* React filtered toolbar and collection slide parity */
(() => {
  const categoryLabels = {
    rings: 'Rings',
    necklace: 'Necklace',
    'toe-rings': 'Toe Rings',
    anklets: 'Anklets',
    chains: 'Chains',
    bracelets: 'Bracelets',
    earrings: 'Earrings',
    'chain-pendants': 'Chain Pendants'
  };
  const promotionLabels = {
    'new-arrivals': 'New Arrivals',
    'best-sellers': 'Best Sellers'
  };
  const pageSize = 12;
  const parseState = () => {
    const parts = window.location.pathname.split('/').filter(Boolean);
    if (parts[0] !== 'collections') return null;
    return {
      handle: parts[1] || 'all',
      tag: ['men', 'women'].includes(parts[2]) ? parts[2] : '',
      params: new URL(window.location.href).searchParams
    };
  };
  const makeUrl = (change) => {
    const url = new URL(window.location.href);
    const parts = url.pathname.split('/').filter(Boolean);
    const draft = {
      handle: parts[1] || 'all',
      tag: ['men', 'women'].includes(parts[2]) ? parts[2] : ''
    };
    change(draft, url.searchParams);
    url.pathname = '/collections/' + encodeURIComponent(draft.handle || 'all') + (draft.tag ? '/' + encodeURIComponent(draft.tag) : '');
    url.searchParams.delete('page');
    if (!url.searchParams.has('sort_by')) url.searchParams.set('sort_by', 'created-ascending');
    url.hash = 'ProductGridContainer';
    return url.pathname + url.search + url.hash;
  };
  const formatMoney = (value) => '₹' + Number(value).toLocaleString('en-IN');
  const getChips = () => {
    const state = parseState();
    if (!state) return [];
    const chips = [];
    if (categoryLabels[state.handle]) {
      chips.push({
        key: 'category-' + state.handle,
        label: categoryLabels[state.handle],
        href: makeUrl((draft) => { draft.handle = 'all'; })
      });
    } else if (promotionLabels[state.handle]) {
      chips.push({
        key: 'promotion-' + state.handle,
        label: promotionLabels[state.handle],
        href: makeUrl((draft) => { draft.handle = 'all'; })
      });
    }
    if (state.tag) {
      chips.push({
        key: 'gender-' + state.tag,
        label: state.tag === 'men' ? 'Men' : 'Women',
        href: makeUrl((draft) => { draft.tag = ''; })
      });
    }
    if (state.params.get('offer') === 'first-purchase') {
      chips.push({
        key: 'offer-first-purchase',
        label: 'First purchase',
        href: makeUrl((draft, params) => { params.delete('offer'); })
      });
    }
    state.params.getAll('rating').forEach((rating) => {
      chips.push({
        key: 'rating-' + rating,
        label: rating + (rating === '1' ? ' Star' : ' Stars'),
        href: makeUrl((draft, params) => {
          const remaining = params.getAll('rating').filter((value) => value !== rating);
          params.delete('rating');
          remaining.forEach((value) => params.append('rating', value));
        })
      });
    });
    const availability = state.params.getAll('filter.v.availability');
    availability.forEach((value) => {
      chips.push({
        key: 'availability-' + value,
        label: value === '0' ? 'Out of Stock' : 'In Stock',
        href: makeUrl((draft, params) => { params.delete('filter.v.availability'); })
      });
    });
    const hasMin = state.params.has('filter.v.price.gte');
    const hasMax = state.params.has('filter.v.price.lte');
    if (hasMin || hasMax) {
      const min = hasMin ? state.params.get('filter.v.price.gte') : 500;
      const max = hasMax ? state.params.get('filter.v.price.lte') : 15000;
      chips.push({
        key: 'price-' + min + '-' + max,
        label: formatMoney(min) + ' - ' + formatMoney(max),
        href: makeUrl((draft, params) => {
          params.delete('filter.v.price.gte');
          params.delete('filter.v.price.lte');
        })
      });
    }
    return chips;
  };
  const clearHref = () => {
    const current = new URL(window.location.href);
    const params = new URLSearchParams();
    params.set('sort_by', current.searchParams.get('sort_by') || 'created-ascending');
    if (current.searchParams.has('preview_theme_id')) params.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
    return '/collections/all?' + params.toString() + '#ProductGridContainer';
  };
  const renderFilteredToolbar = () => {
    const container = document.querySelector('#ProductGridContainer');
    const collection = container && container.querySelector('.collection');
    if (!container || !collection) return;
    const chips = getChips();
    const signature = chips.map((chip) => chip.key).join('|');
    let row = container.querySelector(':scope > .the925-active-filter-row');
    if (!chips.length) {
      if (row) row.remove();
      document.querySelectorAll('.the925-toolbar-clear').forEach((item) => item.remove());
      return;
    }
    if (!row || row.dataset.signature !== signature) {
      if (row) row.remove();
      row = document.createElement('div');
      row.className = 'the925-active-filter-row';
      row.dataset.signature = signature;
      chips.forEach((chip) => {
        const wrapper = document.createElement('span');
        wrapper.className = 'the925-active-filter-chip';
        wrapper.append(document.createTextNode(chip.label));
        const remove = document.createElement('a');
        remove.className = 'the925-active-filter-chip__remove';
        remove.href = chip.href;
        remove.setAttribute('aria-label', 'Remove ' + chip.label + ' filter');
        remove.textContent = '×';
        wrapper.append(remove);
        row.append(wrapper);
      });
      container.insertBefore(row, collection);
    }
    const countWrap = document.querySelector('.product-count-vertical');
    if (countWrap && !countWrap.querySelector('.the925-toolbar-clear')) {
      const clear = document.createElement('a');
      clear.className = 'the925-toolbar-clear';
      clear.href = clearHref();
      clear.textContent = 'Clear All';
      countWrap.append(clear);
    }
  };
  const filterCategoryCarousel = () => {
    const state = parseState();
    if (!state || !categoryLabels[state.handle]) return;
    const carousel = document.querySelector('[data-the925-shop-loop]');
    if (!carousel || carousel.dataset.categoryFiltered === state.handle) return;
    const slides = [...carousel.querySelectorAll('[data-the925-shop-slide]')];
    const label = categoryLabels[state.handle].toLowerCase();
    const match = slides.find((slide) => {
      const collectionLink = slide.querySelector('a[href*="/collections/' + state.handle + '"]');
      const imageSource = slide.querySelector('img')?.getAttribute('src') || '';
      const imageKey = state.handle === 'chain-pendants' ? 'pendants' : state.handle;
      return collectionLink || imageSource.toLowerCase().includes('the925-carousel-' + imageKey + '.') || slide.textContent.toLowerCase().includes(label);
    });
    if (!match) return;
    const clone = carousel.cloneNode(true);
    const track = clone.querySelector('[data-the925-shop-track]');
    if (!track) return;
    track.replaceChildren(match.cloneNode(true));
    track.style.transform = 'translateX(0)';
    const onlySlide = track.querySelector('[data-the925-shop-slide]');
    if (onlySlide) onlySlide.setAttribute('aria-hidden', 'false');
    clone.dataset.loopReady = 'true';
    clone.dataset.categoryFiltered = state.handle;
    carousel.replaceWith(clone);
  };
  const formatCount = () => {
    const count = document.querySelector('.product-count__text');
    if (!count) return;
    const numbers = (count.textContent.match(/[\d,]+/g) || []).map((value) => Number(value.replace(/,/g, '')));
    if (!numbers.length) return;
    const total = numbers[numbers.length - 1];
    const page = Math.max(1, Number(new URL(window.location.href).searchParams.get('page') || 1));
    const start = total ? ((page - 1) * pageSize) + 1 : 0;
    const end = Math.min(page * pageSize, total);
    count.textContent = 'Showing ' + start + ' - ' + end + ' of ' + total + ' products';
  };
  const sync = () => {
    if (!parseState()) return;
    filterCategoryCarousel();
    renderFilteredToolbar();
    formatCount();
  };
  if (!document.documentElement.dataset.the925AvailabilityRadio) {
    document.documentElement.dataset.the925AvailabilityRadio = 'true';
    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || target.name !== 'filter.v.availability' || !target.checked) return;
      const form = target.closest('form');
      if (!form) return;
      form.querySelectorAll('input[name="filter.v.availability"]').forEach((input) => {
        if (input !== target) input.checked = false;
      });
    }, true);
  }
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    window.setTimeout(() => {
      pending = false;
      sync();
    }, 0);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();


/* Mobile navigation drawer behaviour and focus management */
(() => {
  const initialiseMobileMenus = (root = document) => {
    root.querySelectorAll('[data-the925-mobile-menu]').forEach((menu) => {
      if (menu.dataset.drawerReady === 'true') return;
      menu.dataset.drawerReady = 'true';

      const trigger = menu.querySelector(':scope > summary');
      const panel = menu.querySelector(':scope > .the925-mobile-menu__panel');
      const closeControls = menu.querySelectorAll('[data-the925-mobile-close]');
      if (!trigger || !panel) return;

      const closeMenu = (restoreFocus = true) => {
        menu.open = false;
        document.documentElement.classList.remove('the925-mobile-menu-open');
        trigger.setAttribute('aria-label', 'Open menu');
        if (restoreFocus) trigger.focus();
      };

      closeControls.forEach((control) => {
        control.addEventListener('click', () => closeMenu(true));
      });

      panel.addEventListener('click', (event) => {
        if (event.target.closest('a[href]')) closeMenu(false);
      });

      menu.addEventListener('toggle', () => {
        document.documentElement.classList.toggle('the925-mobile-menu-open', menu.open);
        trigger.setAttribute('aria-label', menu.open ? 'Close menu' : 'Open menu');
        if (menu.open) {
          window.requestAnimationFrame(() => panel.querySelector('.the925-mobile-menu__close')?.focus());
        }
      });

      menu.addEventListener('keydown', (event) => {
        if (!menu.open) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          closeMenu(true);
          return;
        }
        if (event.key !== 'Tab') return;

        const focusable = Array.from(panel.querySelectorAll('a[href], button:not([disabled]), summary'))
          .filter((element) => !element.closest('[hidden]') && element.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    });
  };

  const start = () => initialiseMobileMenus();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', (event) => initialiseMobileMenus(event.target));
})();

/* Branded entry point for Shopify's secure passwordless customer accounts. */
(() => {
  const initialiseAccountDialog = () => {
    if (document.querySelector('[data-the925-auth-modal]')) return;

    const createElement = (tagName, className, text) => {
      const element = document.createElement(tagName);
      if (className) element.className = className;
      if (text) element.textContent = text;
      return element;
    };

    const root = createElement('div', 'the925-auth-modal');
    root.dataset.the925AuthModal = '';
    root.hidden = true;
    root.inert = true;

    const backdrop = createElement('button', 'the925-auth-modal__backdrop');
    backdrop.type = 'button';
    backdrop.tabIndex = -1;
    backdrop.dataset.the925AuthClose = '';
    backdrop.setAttribute('aria-label', 'Close login dialog');

    const dialog = createElement('section', 'the925-auth-modal__dialog');
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'the925-auth-title');
    dialog.setAttribute('aria-describedby', 'the925-auth-description the925-auth-note');
    dialog.tabIndex = -1;

    const closeButton = createElement('button', 'the925-auth-modal__close');
    closeButton.type = 'button';
    closeButton.dataset.the925AuthClose = '';
    closeButton.setAttribute('aria-label', 'Close login dialog');
    const closeIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    closeIcon.setAttribute('viewBox', '0 0 24 24');
    closeIcon.setAttribute('fill', 'none');
    closeIcon.setAttribute('stroke', 'currentColor');
    closeIcon.setAttribute('aria-hidden', 'true');
    const closePath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    closePath.setAttribute('d', 'M6 6l12 12M18 6 6 18');
    closeIcon.append(closePath);
    closeButton.append(closeIcon);

    const eyebrow = createElement('p', 'the925-auth-modal__eyebrow', 'THE 925 CLUB');
    const title = createElement('h2', 'the925-auth-modal__title', 'Login / Sign up');
    title.id = 'the925-auth-title';
    const description = createElement(
      'p',
      'the925-auth-modal__description',
      'Continue with your email to access your account. Shopify will send a secure one-time verification code.'
    );
    description.id = 'the925-auth-description';

    const benefits = createElement('ul', 'the925-auth-modal__benefits');
    ['Track orders in one place', 'Save favourites to your wishlist', 'Access member offers faster'].forEach((label) => {
      benefits.append(createElement('li', '', label));
    });

    const continueLink = createElement('a', 'the925-auth-modal__continue', 'Continue with email');
    continueLink.href = '/account/login';

    const note = createElement(
      'p',
      'the925-auth-modal__note',
      'New here? Your account is created automatically after email verification. No password is required.'
    );
    note.id = 'the925-auth-note';

    const dismissButton = createElement('button', 'the925-auth-modal__dismiss', 'Not now');
    dismissButton.type = 'button';
    dismissButton.dataset.the925AuthClose = '';

    dialog.append(closeButton, eyebrow, title, description, benefits, continueLink, note, dismissButton);
    root.append(backdrop, dialog);
    document.body.append(root);

    let returnFocusTo = null;
    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const closeDialog = () => {
      if (root.hidden) return;
      root.hidden = true;
      root.inert = true;
      document.documentElement.classList.remove('the925-auth-modal-open');
      const focusTarget = returnFocusTo;
      returnFocusTo = null;
      if (focusTarget && document.contains(focusTarget)) focusTarget.focus();
    };

    const openDialog = (trigger) => {
      returnFocusTo = trigger && trigger.closest('#the925-account-menu') ? document.querySelector('.the925-account') : (trigger || document.activeElement);
      const accountMenu = document.querySelector('#the925-account-menu');
      const accountToggle = document.querySelector('.the925-account');
      if (accountMenu) {
        accountMenu.classList.remove('is-open');
        accountMenu.setAttribute('aria-hidden', 'true');
        accountMenu.inert = true;
      }
      if (accountToggle) accountToggle.setAttribute('aria-expanded', 'false');
      root.hidden = false;
      root.inert = false;
      document.documentElement.classList.add('the925-auth-modal-open');
      window.requestAnimationFrame(() => dialog.focus());
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.the925-account-menu__link--primary[href*="/account/login"], [data-the925-auth-open]');
      if (!trigger) return;
      event.preventDefault();
      openDialog(trigger);
    });

    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-the925-auth-close]')) closeDialog();
    });

    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDialog();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll(focusableSelector)];
      if (!focusable.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAccountDialog, { once: true });
  } else {
    initialiseAccountDialog();
  }
  document.addEventListener('shopify:section:load', initialiseAccountDialog);
})();
